import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';
import { checkJuristGrade, checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    studyStatus: checkRequiredText(settings),
    university: checkRequiredText(settings),
    doctorate: checkRequiredText(settings),
    masterOfLaws: checkRequiredText(settings),
    professorialChair: Yup.string().when("doctorate", {
        is: (doctorate) => (doctorate === Options.Doctorate[0] || doctorate === Options.Doctorate[1]),
        then: checkRequiredText(settings)
    }),
    stateExamTotalScore: checkJuristGrade,
    stateExamStatePart: checkJuristGrade,
    stateExamUniversityPart: checkJuristGrade,
    secondStateExam: checkJuristGrade,
});

export const StudyOfLawSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId='abiturnote'>
                <Form.Label>Abiturnote</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder={'Abiturnote'}
                    type="number"
                    name='abiturnote'
                    value={values.abiturnote || ''}
                    isValid={touched.abiturnote && !errors.abiturnote}
                    isInvalid={errors.abiturnote}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.abiturnote}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='studyStatus'>
                <Form.Label>Status Studium*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='studyStatus'
                    value={values.studyStatus}
                    isValid={touched.studyStatus && !errors.studyStatus}
                    isInvalid={touched.studyStatus && errors.studyStatus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.StudyStatus.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.studyStatus}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='university'>
                <Form.Label>Aktuelle / Letzte Universität*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='university'
                    value={values.university}
                    isValid={touched.university && !errors.university}
                    isInvalid={touched.university && errors.university}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.Universities.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.university}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='stateExamTotalScore'>
                <Form.Label>1. Staatsexamen Gesamtpunktzahl</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='1. Staatsexamen Gesamtpunktzahl'
                    type="number"
                    name='stateExamTotalScore'
                    value={values.stateExamTotalScore || ''}
                    isValid={touched.stateExamTotalScore && !errors.stateExamTotalScore}
                    isInvalid={errors.stateExamTotalScore}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.stateExamTotalScore}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='stateExamStatePart'>
                <Form.Label>1. Staatsexamen staatlicher Teil</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='1. Staatsexamen staatlicher Teil'
                    type="number"
                    name='stateExamStatePart'
                    value={values.stateExamStatePart || ''}
                    isValid={touched.stateExamStatePart && !errors.stateExamStatePart}
                    isInvalid={errors.stateExamStatePart}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.stateExamStatePart}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='stateExamUniversityPart'>
                <Form.Label>1. Staatsexamen universitärer Teil</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='1. Staatsexamen universitärer Teil'
                    type="number"
                    name='stateExamUniversityPart'
                    value={values.stateExamUniversityPart || ''}
                    isValid={touched.stateExamUniversityPart && !errors.stateExamUniversityPart}
                    isInvalid={errors.stateExamUniversityPart}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.stateExamUniversityPart}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='secondStateExam'>
                <Form.Label>2. Staatsexamen</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='2. Staatsexamen'
                    type="number"
                    name='secondStateExam'
                    value={values.secondStateExam || ''}
                    isValid={touched.secondStateExam && !errors.secondStateExam}
                    isInvalid={errors.secondStateExam}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.secondStateExam}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='doctorate'>
                <Form.Label>Promotion*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='doctorate'
                    value={values.doctorate}
                    isValid={touched.doctorate && !errors.doctorate}
                    isInvalid={touched.doctorate && errors.doctorate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.Doctorate.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.doctorate}
                </Form.Control.Feedback>
            </Form.Group>

            {
                (values.doctorate === Options.Doctorate[0] || values.doctorate === Options.Doctorate[1]) &&
                <Form.Group className="mb-3" controlId='professorialChair'>
                    <Form.Label>Lehrstuhl / Betreuer*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder='Lehrstuhl / Betreuer'
                        type="text"
                        name='professorialChair'
                        value={values.professorialChair}
                        isValid={touched.professorialChair && !errors.professorialChair}
                        isInvalid={touched.professorialChair && errors.professorialChair}
                        maxLength={settings.textInputLimit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                    </CustomFormControl>
                    <Form.Control.Feedback type="invalid">
                        {errors.professorialChair}
                    </Form.Control.Feedback>
                </Form.Group>
            }

            <Form.Group className="mb-3" controlId='masterOfLaws'>
                <Form.Label>LL.M.*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='masterOfLaws'
                    value={values.masterOfLaws}
                    isValid={touched.masterOfLaws && !errors.masterOfLaws}
                    isInvalid={touched.masterOfLaws && errors.masterOfLaws}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.MasterOfLaws.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.masterOfLaws}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};